var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_main"},[_c(_vm.currentComponent,{key:_vm.currentComponent,tag:"component"}),_c('div',{staticClass:"backTop",style:(_vm.show ? 'opacity: 1;visibility: visible;' : 'opacity: 0;visibility: hidden;'),on:{"click":_vm.backToTop}},[_c('VyIcon',{attrs:{"name":"回到顶部","scale":"2.5"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }